import { defineComponent as _defineComponent } from 'vue'
import { computed } from '@nuxtjs/composition-api'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseLogo',
  props: {
    fill: null,
    svgClass: null
  },
  setup(__props: any) {


const companyName = 'HYRE'

return { __sfc: true,companyName }
}

})